import { Link } from "react-router-dom";

const footerLinks = [
  { to: "/", label: "Home" },
  { to: "/#products", label: "Products" },
  { to: "/support", label: "Support" },
  { to: "/privacy", label: "Privacy" },
  { to: "/terms", label: "Terms" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      style={{ borderTop: "1px solid var(--af-border)", background: "var(--af-bg)" }}
    >
      <div className="af-container" style={{ paddingTop: "3.5rem", paddingBottom: "3.5rem" }}>
        <div className="grid gap-10 md:grid-cols-2">
          <div>
            <div style={{ color: "#fff", fontWeight: 700, fontSize: "1.05rem", letterSpacing: "-0.01em" }}>
              AithorityForge Solutions Ltd.
            </div>
            <div className="af-body" style={{ marginTop: 8 }}>
              Regina, Saskatchewan, Canada
            </div>
            <div className="af-body" style={{ marginTop: 18, fontSize: "0.85rem" }} data-testid="footer-copyright">
              © 2026 AithorityForge Solutions Ltd. All rights reserved.
            </div>
          </div>

          <nav
            aria-label="Footer navigation"
            data-testid="footer-nav"
            className="flex flex-wrap gap-x-8 gap-y-3 md:justify-end"
          >
            {footerLinks.map((l) => (
              <Link
                key={l.label}
                to={l.to}
                data-testid={`footer-link-${l.label.toLowerCase()}`}
                className="af-nav-link"
                style={{ padding: 0 }}
              >
                {l.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
